module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_06@3x-73636f2dc7ea1b2430d2b601b0395dbd.webp";